import { FC } from 'react';
import MarketLiquidityRiskTable from './MarketLiquidityRIskTable.component';
import { Grid } from '@mui/material';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useMarketLiquidityRiskPageModel } from '../../../../api/rs-hg/liquidity/hooks/queries';

const MarketLiquidityRisk: FC<FundInfoComponentProps> = (props) => {
  const activeDate = props.positionDate;

  const query = useMarketLiquidityRiskPageModel(props.fundId, activeDate);

  return (
    <QueryBoundary
      isLoading={query.isLoading}
      isFetching={query.isFetching}
      isError={query.isError}
      error={query.error}
      data={query.data?.data}
      loadingMessages={['Loading Market Liquidity Risk Data…']}
      noDataMessage="No data available."
    >
      {(pageData) => (
        <Grid container>
          <MarketLiquidityRiskTable
            data={pageData}
            title="Market Liquidity Risk"
          />
        </Grid>
      )}
    </QueryBoundary>
  );
};

export default MarketLiquidityRisk;
